/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

// CHILDREN
import AdminEducationSection from '../AdminEducationSection.js'

// ASSETS
import './AdminEducationSectionsForm.scss'

class AdminEducationSectionsForm extends Component {
  renderEducationSections = () => {
    const {
      formState: { education_sections },
      sendSectionData,
      deleteSection,
      deleteLesson,
      isEditModal,
      t,
    } = this.props

    if (education_sections && education_sections.length > 0) {
      return education_sections.map((section, index) => (
        <div className='admin-section' key={section.order}>
          <h1>
            {t('education.sectionsForm.sectionNumber', { number: index + 1 })}
          </h1>
          <AdminEducationSection
            section={section}
            index={index}
            sendSectionData={sendSectionData}
            deleteSection={deleteSection}
            deleteLesson={deleteLesson}
            isEditModal={isEditModal}
          />
          <div className='section-divider' />
        </div>
      ))
    }
    return null
  }

  render() {
    const {
      formState,
      addSection,
      previous,
      loader,
      createEducation,
      updateEducation,
      isEditModal,
      t,
    } = this.props
    return (
      <div id='AdminEducationSectionsForm'>
        <h4>
          {t(
            isEditModal
              ? 'education.sectionsForm.startUpdatingSections'
              : 'education.sectionsForm.startCreatingSections',
            { name: formState.name }
          )}
        </h4>
        <p>{t('education.sectionsForm.instructions')}</p>
        {this.renderEducationSections()}
        <div className='add-section-button-wrapper'>
          <button className='animation-shrink' onClick={addSection}>
            <i className='fa fa-plus' aria-hidden='true' />
          </button>
        </div>
        <div className='col-md-12 d-flex justify-content-center align-items-center mt-4'>
          <button
            className='btn btn-dark m-2'
            onClick={previous}
            disabled={loader}
          >
            {t('education.common.editEducation')}
          </button>
          <button
            className='btn btn-primary m-2'
            onClick={isEditModal ? updateEducation : createEducation}
            disabled={loader}
          >
            {t(
              isEditModal
                ? 'education.common.updateEducation'
                : 'education.common.createEducation'
            )}
          </button>
        </div>
      </div>
    )
  }
}

export default withTranslation()(AdminEducationSectionsForm)
